// Core React imports.
import React from "react";
import * as ReactDOM from "react-dom/client";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import {StoreProvider} from './store/StoreProvider'

// Layout import.
import EngageLayout from "./layouts/EngageLayout";

// Stylesheet imports.
import './assets/less/main.less';

const router = createBrowserRouter([
  {
    path: "/*",
    element: <EngageLayout />,
  },
]);


ReactDOM.createRoot(document.getElementById("root")).render(
    <StoreProvider>
        <RouterProvider router={router} />
    </StoreProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
